import { getZoneVerticesData } from "../../../../Manager/CommonDataManager";
import { toast } from 'react-toastify';
import APICom from "../../../../utils/helpers/APICom";
import { Icon } from '@iconify/react';
import mapIcon from '@iconify-icons/mdi/home-circle-outline';


  var depotMarkers = [];
  var depotInfo = [];
  export async function getAndPlotAllDepots(map, maps, selectedDate, selectedAff){
    try {
        toast.success("Plotting Depos on the Map.");
        let params = {
            "dtServiceDate": selectedDate,
            "vAffID": selectedAff.toString(), //"12/06/2023",
            "iSettingID": "-1",
        };
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllDepots", "post", { "Content-Type": "application/json" }, params,  null);
        let result = response.data;
        if(result.length > 0)
        {
            try{
                for(let y = 0; y < result.length; y++)
                {
                    depotMarkers.push(new maps.Marker({
                        position: {
                        lat: parseFloat(result[y].DepotLatitude),
                        lng: parseFloat(result[y].DepotLongitude),
                        },
                        map,
                        icon: "https://maps.gstatic.com/mapfiles/ms2/micons/homegardenbusiness.png",
                    }));
                    depotInfo.push(new maps.InfoWindow({
                        content: `<div>
                        <div class="text-start">
                        <b class="fw-bold float-left">Depot Name: </b>${result[y].DepotName} <br>
                        <b class="fw-bold">Address: </b> ${result[y].DepotAddress} <br></div>
                    </div>`,
                    }));
                }
                depotMarkers.forEach((marker, i)=>{
                    marker.addListener('mouseover', () => {
                        depotInfo[i].open(map, marker);
                    });
                    marker.addListener("mouseout", () => {
                        depotInfo[i].close();
                    });
                });
            }
            catch(err){console.log(err);}
        }
        else
        {
            console.log("No depot given");
        }
        return [depotMarkers, depotInfo]
    }
    catch(err){console.log(err);}
  }

  export function clearDeposFromMap(depoMarkers, depotInfo) {
    depoMarkers.forEach(marker => marker.setMap(null));
    depotInfo.forEach(marker => marker.setMap(null));
    toast.warning("Hiding Depos from the map.");
  }
  